import { Add, Close, Edit } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import React, { FC, useCallback, useState } from 'react';
import { StudentFormEditInterface, StudentInterface } from '../../interfaces';
import { useTranslation } from '../../services';
import { Student } from '../Student';

interface EditStudentDialogInterface extends StudentFormEditInterface {
	mode?: 'create' | 'update';
}

const EditStudentDialog: FC<EditStudentDialogInterface> = ({
	index,
	value,
	update,
	error,
	mode = 'update',
}) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	const handleUpdate = useCallback(
		(index: number, value: StudentInterface) => {
			update(index, value);
			setOpen(false);
		},
		[update]
	);

	return (
		<>
			{mode === 'update' ? (
				<IconButton
					onClick={handleClickOpen}
					title={t('Edit Student')}
					color="primary"
				>
					<Edit />
				</IconButton>
			) : (
				<IconButton
					onClick={handleClickOpen}
					title={t('Add Student')}
					color="primary"
				>
					<Add />
				</IconButton>
			)}
			<Dialog open={open} onClose={handleClose} fullWidth>
				<DialogTitle>
					{mode === 'update' ? t('Edit Student') : t('Add Student')}
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<Close />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<Grid container spacing={2}>
						<Student
							update={handleUpdate}
							value={{ ...value, notes: '' }}
							index={index}
							withNotes
						/>
					</Grid>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default EditStudentDialog;
